import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PlayerService } from '../../services/player/player.service';
import { BreadcrumbService } from 'app/shared/services/breadcrumb/breadcrumb.service';

export const playerResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot
): Observable<any> => {
    const playerService = inject(PlayerService);
    const _breadcrumbService = inject(BreadcrumbService);
    const id = route.paramMap.get('id');

    if (!id || isNaN(Number(id))) {
        return of(null);
    }

    return playerService.get(Number(id)).pipe(
        map((player) => {
            if (player) {
                _breadcrumbService.updateBreadcrumbs([
                    { label: 'navigation.players.title', link: '/players' },
                    { label: player?.username },
                ]);
            }
            return player;
        }),
        catchError(() => of(null))
    );
};
